import _debug from 'debug'
import { camelCase } from './shared/utils'

const debug = _debug('app:store')

function requireAll(requireContext) {
  return requireContext.keys()
    .filter((name) => {
      // ignore non-domain folders
      return name.indexOf('shared') === -1
        && name.indexOf('config') === -1
    })
    .reduce((memo, key) => {
      const store = requireContext(key).store
      if (store) {
        try {
          const name = camelCase(key.match(/\.\/([^/]+)\//)[1])
          debug(`Adding store for: ${name}`)
          memo[name] = requireContext(key).store
        }
        catch (ex) {
          console.error(new Error(`Could not add store for ${key}`))
        }
      }
      return memo
    }, {})
}

export default requireAll(require.context('./', true, /^\.\/[^/]+\/index.js$/))



// WEBPACK FOOTER //
// ./src/stores.js